/**
 * Ryan O'Dowd
 * 2022-12-19
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Passage from './Passage';

export default class AssignmentSettings {
  isAdmin: boolean;
  type: string;
  assignmentName: string;
  noAssignmentName: string;
  passage: Passage;
  verseMemoryNumLessonsToComplete: number;
  verseMemoryGameTypesEnabled: string;
  verseMemoryGameDifficulty: string;
  verseMemoryMustMemorize: boolean;
  lectureText: string;

  constructor(isAdmin, type, assignmentName, noAssignmentName, passage, verseMemoryNumLessonsToComplete, verseMemoryGameTypesEnabled, verseMemoryGameDifficulty, verseMemoryMustMemorize, lectureText) {
    this.isAdmin = isAdmin;
    this.type = type;
    this.assignmentName = assignmentName;
    this.noAssignmentName = noAssignmentName;
    this.passage = passage;
    this.verseMemoryNumLessonsToComplete = verseMemoryNumLessonsToComplete;
    this.verseMemoryGameTypesEnabled = verseMemoryGameTypesEnabled;
    this.verseMemoryGameDifficulty = verseMemoryGameDifficulty;
    this.verseMemoryMustMemorize = verseMemoryMustMemorize;
    this.lectureText = lectureText;
  }

  _isValidPassage() {
    return this.passage && this.passage.book_id && this.passage.chapter_number && this.passage.start_verse_number && this.passage.end_verse_number;
  }

  validateAndMarshal() { // @TODO: more specific exceptions with better error messages
    if (!this.assignmentName && !this.isAdmin && !this.noAssignmentName) {
      // @NOTE: this condition is required because noAssignmentName is valid only for verse_memories
      throw new Error('Assignment name is required');
    } else if (this.type === 'verse_memory') {
      if (!this._isValidPassage()) {
        // all other fields are optional
        throw new Error('Passage is required');
      }
      return {
        passage: this.passage,
        verseMemoryNumLessonsToComplete: this.verseMemoryNumLessonsToComplete,
        verseMemoryGameTypesEnabled: Object.entries(this.verseMemoryGameTypesEnabled).filter(([__key, value]) => value).map(([key]) => +key),
        verseMemoryGameDifficulty: this.verseMemoryGameDifficulty === 'choice' ? null : this.verseMemoryGameDifficulty,
        verseMemoryMustMemorize: this.verseMemoryMustMemorize,
      };
    } else if (this.type === 'reading') {
      if (!this._isValidPassage()) {
        // all other fields are optional
        throw new Error('Passage is required');
      }
      return {
        passage: this.passage,
      };
    } else if (this.type === 'lecture') {
      if (!this.lectureText) {
        throw new Error('Text is required');
      }
      return {
        lectureText: this.lectureText,
      };
    }
  }
}
